<script lang="ts" setup>
withDefaults(
  defineProps<{
    count?: string | number | null
    isActive: boolean
    name: string
    isWhiteMode?: boolean
  }>(),
  { count: null, isWhiteMode: false },
)
</script>

<template>
  <a
    class="
      flex w-full items-center justify-center rounded-xl px-9 py-2.5 text-center text-sm leading-[1.71]
      !no-underline md:w-min
    "
    :class="{ 'bg-main-green font-medium': isActive && !isWhiteMode, 'bg-white': isActive && isWhiteMode }"
    href="#"
  >
    <span
      class="text-nowrap text-[#5B5B5B]"
      :class="{ '!text-white': isActive && !isWhiteMode, '!text-main-dark': isActive && isWhiteMode }"
    >
      {{ name }}
    </span>

    <span
      v-if="count !== null"
      class="inline-block pl-1 text-[rgba(91,91,91,0.3)]"
      :class="{ '!text-[rgba(255,255,255,0.5)]': isActive }"
    >
      {{ count }}
    </span>
  </a>
</template>
